module.exports = __webpack_public_path__ + "img/Origine_France_Officiel.8d943c52.png";